import Vue from "vue";
import Router from "vue-router";
import user from "@/store/user.js";

// Containers
function TheContainer() {
  return import("@/containers/TheContainer");
}

// Views - Settings
const Profile = () => import("@/views/profile/Index.vue");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");
const Idea = () => import("@/views/idea/Index.vue");
const IdeaDetail = () => import("@/views/idea/Detail.vue");
const Challenge = () => import("@/views/challenge/Index.vue");
const ChallengeDetail = () => import("@/views/challenge/Detail.vue");
const Notice = () => import("@/views/notice/Index.vue");

Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes: configRoutes(),
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (user.getters.authUser) {
      next();
      return;
    }
    let query = to.fullPath ? { returnUrl: to.fullPath } : null;
    next({ name: "Login", query });
  } else {
    next();
  }
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/idea",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "settings",
          redirect: "/settings/profile",
          name: "Settings",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "profile",
              name: "Profile",
              component: Profile,
            },
          ],
        },
        {
          path: "idea",
          name: "Idea",
          component: Idea,
        },
        {
          path: "idea-detail/:id",
          name: "IdeaDetail",
          component: IdeaDetail,
        },
        {
          path: "challenge",
          name: "Challenge",
          component: Challenge,
        },
        {
          path: "challenge-detail/:id",
          name: "ChallengeDetail",
          component: ChallengeDetail,
        },
        {
          path: "notification",
          name: "Notice",
          component: Notice,
        },
      ],
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },
  ];
}

export default router;
